import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SearchInformationService {
	private getEnduserUrl = environment.baseApiUrl + 'enduser';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	searchUserData(form: genericFormInterface[], idCustomer?: number): Observable<enduserInterface[]> {
		const parameters = {
			idCustomer: idCustomer,
		};
		for (const formItem of form) {
			parameters[formItem.name] = formItem.values[0];
		}
		return this.http.get<enduserInterface[]>(this.getEnduserUrl, { headers: this.headers, params: parameters });
	}
}
